import AxiosConfig from '../utils/AxiosConfig';

class LearningService {
  async getCourses() {
    const response = await AxiosConfig.get('/learning/courses');
    return response.data?.data || response.data || [];
  }

  async getGuideAssets(guideId) {
    const response = await AxiosConfig.get(`/learning/guides/${guideId}/assets`);
    return response.data?.data || response.data;
  }

  async getEditorCourses() {
    const response = await AxiosConfig.get('/learning/admin/courses');
    return response.data?.data || response.data || [];
  }

  async getPermissionCatalog() {
    const response = await AxiosConfig.get('/learning/admin/permissions');
    return response.data?.data || response.data || [];
  }

  async getAssetPreview(key) {
    const response = await AxiosConfig.get('/learning/admin/assets/preview', { params: { key } });
    return response.data?.data?.url || response.data?.url || null;
  }

  async createCourse(course) {
    const response = await AxiosConfig.post('/learning/admin/courses', course);
    return response.data?.data || response.data;
  }

  async updateCourse(course) {
    const response = await AxiosConfig.put(`/learning/admin/courses/${course.id}`, course);
    return response.data?.data || response.data;
  }

  async deleteCourse(courseId) {
    await AxiosConfig.delete(`/learning/admin/courses/${courseId}`);
  }

  async uploadImage(file) {
    const body = new FormData();
    body.append('file', file);
    const response = await AxiosConfig.post('/learning/admin/assets', body, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data?.data || response.data;
  }
}

export default new LearningService();
